<template>
  <footer class="main-footer">
    <strong>Copyright &copy; 2021 <a href="https://hawow.id">PT Royal Union</a>.</strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <b class="mr-3">AGS - BUP - BP Batam</b>v{{ version }}
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data: ()=>({
    version: '1.1.0 patch 2022.02-x00',
  })
}
</script>

<style scoped>

</style>
